export default __webpack_public_path__ + "static/media/craon25.28317582.jpg";